import styled from "styled-components";

export const AdminPageHeaderContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;
  column-gap: 10px;
  padding: 10px;
`;
